import React, { useEffect } from "react";
import "./additionalStyles.css";
import { withRouter } from "react-router-dom";

const styles = {
  navbar: {
    width: "100vw",
    maxWidth: "100%",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#494848",
    boxShadow: "0 2px 10px 2px rgba(0,0,0, 0.2)",
  },
  navbarCell: {
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    flex: 1,
  },
  selectedCell: {
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "3px solid #5779CF",
    flex: 1,
  },
  navbarText: {
    margin: "0px",
    fontWeight: 600,
    color: "white",
  },
};

const Navigation = ({ history, location, setExpanded, setBgColor }) => {
  const goTo = (newLocation) => {
    if (newLocation === "Home") {
      setExpanded(false);
      setBgColor("#575757");
      history.push("/");
    } else {
      setBgColor("#281B4B");
      history.push("/about");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    var header = document.getElementById("navbar");
    let sticky = header.offsetHeight + 105;
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  };

  return (
    <div style={styles.navbar} id="navbar">
      <div
        style={
          location.pathname === "/" ? styles.selectedCell : styles.navbarCell
        }
        onClick={() => goTo("Home")}
        className="navbarCell"
      >
        <p style={styles.navbarText}>Home</p>
      </div>
      <div
        style={
          location.pathname === "/about"
            ? styles.selectedCell
            : styles.navbarCell
        }
        onClick={() => goTo("About")}
        className="navbarCell"
      >
        <p style={styles.navbarText}>About Us</p>
      </div>
    </div>
  );
};

export default withRouter(Navigation);
